"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnnestToken = exports.SqlToken = exports.ListToken = exports.JsonToken = exports.JsonBinaryToken = exports.IdentifierToken = exports.ComparisonPredicateToken = exports.BinaryToken = exports.ArrayToken = void 0;
exports.ArrayToken = 'SLONIK_TOKEN_ARRAY';
exports.BinaryToken = 'SLONIK_TOKEN_BINARY';
exports.ComparisonPredicateToken = 'SLONIK_TOKEN_COMPARISON_PREDICATE';
exports.IdentifierToken = 'SLONIK_TOKEN_IDENTIFIER';
exports.JsonBinaryToken = 'SLONIK_TOKEN_JSON_BINARY';
exports.JsonToken = 'SLONIK_TOKEN_JSON';
exports.ListToken = 'SLONIK_TOKEN_LIST';
exports.SqlToken = 'SLONIK_TOKEN_SQL';
exports.UnnestToken = 'SLONIK_TOKEN_UNNEST';
